import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=05fb4338"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fb4338')) {
      api.createRecord('05fb4338', component.options)
    } else {
      api.reload('05fb4338', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=05fb4338", function () {
      api.rerender('05fb4338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/notification-menu/menu.vue"
export default component.exports